module.exports = __webpack_public_path__ + "img/_Cheeky.3bd99b9b.png";